let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gP1mJ")).then(() => parcelRequire('cURTI'));